import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  }
});

export default supabase;
function communeService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: communeService is not implemented yet.', args);
  return null;
}

export { communeService };
function communeManagementService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: communeManagementService is not implemented yet.', args);
  return null;
}

export { communeManagementService };
function propertyService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: propertyService is not implemented yet.', args);
  return null;
}

export { propertyService };
function frontendContentService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: frontendContentService is not implemented yet.', args);
  return null;
}

export { frontendContentService };